export default (addressString?: string) => {
  if (!addressString) {
    return undefined
  }
  const [street, location] = addressString.split(', ')
  return {
    street,
    postcode: location ? location.slice(0, location.indexOf(' ')) : '',
    city: location ? location.slice(1 + location.indexOf(' ')) : '',
  }
}
